import { ExtractRouteParams, RoutesValues } from "store/types";

// Recive route string and object where keys are params and values are ids
// Replace string params :entityId to a relevant object key value { entityId: value }

export default function <Route extends RoutesValues>(
  route: Route,
  params: ExtractRouteParams<Route>
): string | undefined {
  try {
    return route
      .split("/")
      .map((item) => {
        if (new RegExp("^:[a-zA-z]+$").test(item)) {
          const itemToParam = item.substring(1) as keyof ExtractRouteParams<Route>;
          const paramValue = params[itemToParam];
          if (typeof paramValue !== "number" && typeof paramValue !== "string")
            throw new Error("Parameters do not match the path");
          return paramValue;
        }
        return item;
      })
      .join("/");
  } catch (error) {
    throw error;
  }
}

// Old type of extract params ----------------------------------

// type ExtractRouteParams<T extends string> =
//   string extends T
//   ? Record<string, string>
//   : T extends `${infer Start}:${infer Param}/${infer Rest}`
//   ? {[k in Param | keyof ExtractRouteParams<Rest>]: string}
//   : T extends `${infer Start}:${infer Param}`
//   ? {[k in Param]: string}
//   : {};

// Example optional/required params of the func ----------------

// type Settings = {
//   AddPaymentInfo?: string
//   AddToCart?: number
//   Lead?: boolean
//   Purchase: Date
// }

// function track<T extends keyof Settings>(
//     ...args: undefined extends Settings[T]
//       ? [pixelCmd: T, settings?: Settings[T]]
//       : [pixelCmd: T, settings: Settings[T]]
// ) {}

// track("Purchase") // Error: Source has 1 element(s) but target requires 2
// track("Purchase", new Date())
// track("Lead", 2) // Error: type number is not assignable to type boolean | undefined
// track("Lead") // Ok
// track("Lead", true) // Ok
